import { render } from "./live-scoring.vue?vue&type=template&id=391659b2&scoped=true"
import script from "./live-scoring.vue?vue&type=script&lang=js"
export * from "./live-scoring.vue?vue&type=script&lang=js"

import "./live-scoring.vue?vue&type=style&index=0&id=391659b2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-391659b2"]])

export default __exports__